var _g, _g2, _g3, _path, _g4, _g5, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_210_1",
    "data-name": "Component 210 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.254,
    height: 226.797,
    viewBox: "0 0 367.254 226.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11341",
    "data-name": "Group 11341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11340",
    "data-name": "Group 11340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13582",
    "data-name": "Path 13582",
    d: "M146.74,199.155H116.081a30.1,30.1,0,0,0-30,30.032h0a30.1,30.1,0,0,0,30,30.032H375.32A48.748,48.748,0,0,0,423.9,210.589h0a48.748,48.748,0,0,0-48.58-48.63h0A20.612,20.612,0,0,1,354.78,141.4h0a20.612,20.612,0,0,1,20.541-20.562h24.721A21.43,21.43,0,0,0,421.4,99.456h0a21.429,21.429,0,0,0-21.355-21.378H368.781a8.344,8.344,0,0,1-8.314-8.323h0a8.343,8.343,0,0,1,8.314-8.322h5.511a5.758,5.758,0,0,0,5.738-5.744h0a5.758,5.758,0,0,0-5.738-5.744H338.133c-7.615,0-8.464,9.006-27.7,9.006H255.009a7.514,7.514,0,0,0-7.488,7.495h0a7.514,7.514,0,0,0,7.488,7.5h7.19A10.887,10.887,0,0,1,273.048,84.8h0A10.887,10.887,0,0,1,262.2,95.661h-10.82c-29.221,0-33.349,7.645-38.466,22.849s-31.7,16.43-31.7,16.43H144.868a16.405,16.405,0,0,0-16.349,16.366h0a16.405,16.405,0,0,0,16.349,16.366h1.872a15.78,15.78,0,0,1,15.725,15.742h0a15.779,15.779,0,0,1-15.725,15.741ZM390.395,61.432a5.744,5.744,0,1,1,5.738-5.744A5.742,5.742,0,0,1,390.395,61.432Z",
    transform: "translate(-62.812 -49.944)",
    fill: "#e2e8f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13583",
    "data-name": "Path 13583",
    d: "M260.489,173.408a.621.621,0,1,0-1.242,0v1.461h-1.46a.621.621,0,0,0,0,1.243h1.46v1.462a.621.621,0,1,0,1.242,0v-1.462h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-136.995 -103.136)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13584",
    "data-name": "Path 13584",
    d: "M687.182,73.289a.621.621,0,1,0-1.242,0v1.461h-1.459a.621.621,0,0,0,0,1.243h1.459v1.462a.621.621,0,1,0,1.242,0V75.993h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-322.009 -59.784)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13585",
    "data-name": "Path 13585",
    d: "M48.321,359.214a.62.62,0,1,0-1.241,0v1.461H45.62a.621.621,0,0,0,0,1.243h1.46v1.461a.62.62,0,1,0,1.241,0v-1.461h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-44.999 -183.591)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13586",
    "data-name": "Path 13586",
    d: "M357.846,143.81a.621.621,0,1,0-1.242,0v1.461h-1.46a.622.622,0,0,0,0,1.243h1.46v1.461a.621.621,0,1,0,1.242,0v-1.461h1.46a.622.622,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-179.209 -90.32)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13587",
    "data-name": "Path 13587",
    d: "M362.313,265.179a.62.62,0,1,0-1.241,0v1.461h-1.46a.622.622,0,0,0,0,1.243h1.46v1.461a.62.62,0,1,0,1.241,0v-1.461h1.46a.622.622,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-181.146 -142.874)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13588",
    "data-name": "Path 13588",
    d: "M266.26,210.823a.621.621,0,1,0-1.242,0v1.462h-1.46a.621.621,0,0,0,0,1.243h1.46v1.461a.621.621,0,1,0,1.242,0v-1.461h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-139.497 -119.337)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13589",
    "data-name": "Path 13589",
    d: "M630.593,204.338a.621.621,0,1,0-1.242,0V205.8h-1.459a.621.621,0,0,0,0,1.243h1.459V208.5a.621.621,0,1,0,1.242,0v-1.461h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-297.472 -116.529)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11344",
    "data-name": "Group 11344",
    transform: "translate(158.3 85.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342",
    transform: "translate(0 25.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13590",
    "data-name": "Path 13590",
    d: "M469.937,285.652a16.121,16.121,0,0,1,6.615,4.772c1.649,2,21.832,40.713,23.13,43.232s1.293,8.89-1.766,12.811c-1.187,1.523-4.6,5.784-8.329,10.428H477.5c4.391-6.6,10.123-15.22,10.534-15.914.672-1.135,1.009-2.232-.218-4.149s-17.384-21.636-17.384-21.636S462.484,292.966,469.937,285.652Z",
    transform: "translate(-386.169 -262.916)",
    fill: "#0f1630",
    stroke: "#0e1632",
    strokeWidth: 0.216,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13591",
    "data-name": "Path 13591",
    d: "M401.549,280.161s20.352,2.9,21.229,3.113,2.363,2.267,3.163,3.649,1.741,21.268,2.2,26.837-1.339,29.844-.8,36.363c.088,1.082.254,2.6.469,4.393H366.926c-.781-7.21-6.21-29.769-6.654-35.189-.455-5.568-2.762-25.342-2.2-26.836s1.7-3.759,2.527-4.116,20.678-6.55,20.678-6.55l10.175,1.123Z",
    transform: "translate(-339.011 -260.538)",
    fill: "#cec9d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13592",
    "data-name": "Path 13592",
    d: "M416.9,280.161l3.364.481a2.917,2.917,0,0,1-.7,1.382c-7.907,9.072-15.987,9.735-25.264,2.073a2.907,2.907,0,0,1-.916-1.259l3.244-1.014,10.175,1.123Z",
    transform: "translate(-354.36 -260.538)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13593",
    "data-name": "Path 13593",
    d: "M415.822,245.552l.174,5.072.976,11.921c.062.759.941,1.791,2.409,2.631-6.653,7.634-12.463,8.111-20.269,1.663,1.313-1.068,2.012-2.229,1.95-2.989-.129-1.571-.976-11.921-.976-11.921l-.653-5.033s4.086.319,8.323.894C411.842,246.533,415.822,245.552,415.822,245.552Z",
    transform: "translate(-356.843 -245.552)",
    fill: "#e8685b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13594",
    "data-name": "Path 13594",
    d: "M433.888,280.585s-2.353,10.18-2.528,12.252-2.939,22.929-2.65,26.455c.131,1.6,3.315,17.9,6.78,35.409h27.728c-.68-4.267-1.264-7.946-1.577-10.024-1.127-7.47-1.882-22.994-1.636-32.582s-2.134-23.976-2.417-25.342-3-3.072-3.844-3.389Z",
    transform: "translate(-369.667 -260.722)",
    fill: "#0f1630",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13595",
    "data-name": "Path 13595",
    d: "M430.851,305.056c-.834,6.873-2.36,19.433-2.142,22.1,0,0,13.486-14.7,13.282-16.148s-5.692-12.263-5.692-12.263S433.943,301.457,430.851,305.056Z",
    transform: "translate(-369.667 -268.584)",
    fill: "#3d4155",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13596",
    "data-name": "Path 13596",
    d: "M434.378,279.992s.6-.534.81-.552,3.872,1.222,3.872,1.222,5.338,8.4,5.425,9.473-13.108,11.88-13.108,11.88l1.17-9.882s1.913-9.66,2.506-12.045Z",
    transform: "translate(-370.833 -260.226)",
    fill: "#545a6c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13597",
    "data-name": "Path 13597",
    d: "M346.313,294.614a16.127,16.127,0,0,0-5.75,5.787c-1.3,2.247-14.921,43.728-15.79,46.425s.169,8.983,3.824,12.352c.4.365,1,.912,1.754,1.6h15.091c-4-4.291-7.616-8.186-7.982-8.622-.847-1.01-1.358-2.039-.459-4.131s13.633-24.18,13.633-24.18S354.856,300.616,346.313,294.614Z",
    transform: "translate(-324.484 -266.796)",
    fill: "#0f1630",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13598",
    "data-name": "Path 13598",
    d: "M379.1,284s3.977,9.661,4.487,11.677,6.629,22.143,6.918,25.669c.128,1.568-.338,17.462-.893,34.835h-27.43c-.012-1.813-.025-3.336-.04-4.422-.1-7.553-1.883-22.994-3.686-32.414s-1.793-24-1.735-25.4,2.461-3.52,3.241-3.97Z",
    transform: "translate(-338.457 -262.199)",
    fill: "#0f1630",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13599",
    "data-name": "Path 13599",
    d: "M398.634,307.946c1.94,6.645,5.488,18.79,5.707,21.454,0,0-15.7-12.3-15.732-13.768s3.622-13.027,3.622-13.027S395,304.9,398.634,307.946Z",
    transform: "translate(-352.289 -270.256)",
    fill: "#3d4155",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13600",
    "data-name": "Path 13600",
    d: "M391.026,283.318a2.983,2.983,0,0,0-.888-.413c-.214.017-3.622,1.837-3.622,1.837s-3.9,9.158-3.812,10.231,14.865,9.585,14.865,9.585L394.806,295s-3.458-9.219-4.432-11.475Z",
    transform: "translate(-349.727 -261.726)",
    fill: "#545a6c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11343",
    "data-name": "Group 11343",
    transform: "translate(30.563 25.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13601",
    "data-name": "Path 13601",
    d: "M381.7,250.992c-.1.023-.2.05-.3.081h0a4.188,4.188,0,1,0,3.556.522c.219,1.222.161,2.765-1.4,3.061l-.173-2.41A1.44,1.44,0,0,0,381.7,250.992Z",
    transform: "translate(-378.445 -248.245)",
    fill: "#e8685b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13602",
    "data-name": "Path 13602",
    d: "M433.988,246.156c.1.005.208.012.31.024h0a4.19,4.19,0,1,1-3.4,1.157c.006,1.242.341,2.749,1.926,2.758l-.264-2.4A1.44,1.44,0,0,1,433.988,246.156Z",
    transform: "translate(-400.637 -246.156)",
    fill: "#e8685b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13603",
    "data-name": "Path 13603",
    d: "M397.434,211.765h0a14.387,14.387,0,0,0-12.971,15.592l1.184,13a14.381,14.381,0,0,0,15.575,12.986h0a14.386,14.386,0,0,0,12.971-15.592l-1.184-13A14.381,14.381,0,0,0,397.434,211.765Z",
    transform: "translate(-350.465 -205.866)",
    fill: "#f4ad85",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13604",
    "data-name": "Path 13604",
    d: "M385.344,226.568a14.221,14.221,0,0,0-.883,6.4l1.184,13a14.388,14.388,0,0,0,14.214,13.044c-8.3-.639-9.835-10.456-10.469-15.625s1.3-6.328,2.07-6.584,12.82-2.259,15.486-2.567a4.754,4.754,0,0,1,4.007,1.173l1.121-1.635L411,230.277s.92.03,2,0a14.3,14.3,0,0,0-.526-2.7,22.717,22.717,0,0,1-4.709-2.127c-3.179-2.053-18.358.514-20.819.514A3.854,3.854,0,0,0,385.344,226.568Z",
    transform: "translate(-350.464 -211.473)",
    fill: "#ed9072",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13605",
    "data-name": "Path 13605",
    d: "M406.3,227.186s.087.955.168,1.842.993,1.8,1.673,1.739l-.184-2.012a2.01,2.01,0,0,1,1.985-1.678c5.029-6.979,3.353-17.176-3.129-21.95s-19.4-3.939-21.576-2.983-4.149,4.987-4.149,4.987-2.065-1.531-3.756-.483-6.6,12.779-6.346,15.576,6.169,7.847,6.169,7.847a2.007,2.007,0,0,1,2.254,1.29l.183,2.013a1.977,1.977,0,0,0,1.332-2.013l-.168-1.842c.064-.035.126-.073.189-.109,1.731-1.126,1.387-4.565,1.387-4.565l-1.595-2.234,3.166-4.169,3.643-1.2,8.276.318s9.759,1.214,8.9,4.057S406.3,227.186,406.3,227.186Z",
    transform: "translate(-344.644 -201.406)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13606",
    "data-name": "Path 13606",
    d: "M406.3,232.6c.1,1.095.831,5.985,2.1,5.868,3.8-8.006,7.3-16.362,1.647-24.564-.666,5.278-5.918,8.5-11.177,9.605,2.783.607,6.385,1.746,5.851,3.521-.854,2.844,1.575,5.57,1.575,5.57Zm-34.95-7.417a8.3,8.3,0,0,0-.364,2.456c.2,2.156,7.366,12.566,8.958,14.932.829-.075.94-6.242.812-7.637.064-.036.126-.072.189-.109,1.731-1.126,1.387-4.565,1.387-4.565l-1.6-2.234,3.166-4.17,3.475-1.144a5.094,5.094,0,0,1-2.254-1.449C377.943,228.533,373.774,228.135,371.353,225.179Z",
    transform: "translate(-344.644 -206.816)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13607",
    "data-name": "Path 13607",
    d: "M380.952,231.013s-6-13.032,6.074-15.26c0,0,3.2-6.319,9.6-4.734s10.415,1.54,13.288-1.293a5.8,5.8,0,0,1-.353,5.817c6.063,4.709,3.957,10.748,1.477,14.007-.994-6.754-18.768.764-21.092-5.728C389.717,230.026,383.22,228.483,380.952,231.013Z",
    transform: "translate(-348.322 -205.009)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13608",
    "data-name": "Path 13608",
    d: "M380.988,236.689a18.851,18.851,0,0,1-1.447-5.677c2.335-.222,5.363-1.9,9.3-5.885,0,0,1.607,2.364,9.026,2.669,4.506.185,10.234-1.484,13.464-4.962,3.861,4.4,1.952,9.5-.253,12.393-.994-6.754-18.768.764-21.092-5.728C389.752,235.7,383.255,234.158,380.988,236.689Z",
    transform: "translate(-348.357 -210.684)",
    fill: "#010518",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11348",
    "data-name": "Group 11348",
    transform: "translate(244.83 134.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11345",
    "data-name": "Group 11345",
    transform: "translate(1.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13609",
    "data-name": "Path 13609",
    d: "M516.63,291.808c-2.54-9.532-11.413-4.29-15.211,3.87s-12.5,39.993-20.021,48.235c-2.916,3.194-2.024,3.463.656,1.907C495.424,338.062,520.125,304.929,516.63,291.808Z",
    transform: "translate(-479.588 -286.691)",
    fill: "#05304b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13610",
    "data-name": "Path 13610",
    d: "M479.6,349.21c-.092.428.311.448,1.073.133,20.269-17.161,31.033-55.523,31.068-55.646a.4.4,0,0,0-.764-.218C510.945,293.6,500.034,332.488,479.6,349.21Z",
    transform: "translate(-479.589 -289.506)",
    fill: "#0076bd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11346",
    "data-name": "Group 11346",
    transform: "translate(0.185 7.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13611",
    "data-name": "Path 13611",
    d: "M493.3,302.407c-4.429-6.95-10.174-.53-11.138,6.93s.14,35.017-3.771,43.484c-1.516,3.282-.738,3.271,1,1.353C488.085,344.613,499.4,311.973,493.3,302.407Z",
    transform: "translate(-477.582 -299.429)",
    fill: "#0076bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13612",
    "data-name": "Path 13612",
    d: "M477.588,357.662c.035.365.361.278.888-.166,11.813-18.8,10.7-52.074,10.7-52.181a.331.331,0,1,0-.663.019C488.515,305.442,489.642,339.175,477.588,357.662Z",
    transform: "translate(-477.584 -301.838)",
    fill: "#05304b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11347",
    "data-name": "Group 11347",
    transform: "translate(0 33.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13613",
    "data-name": "Path 13613",
    d: "M515.115,346.364c7.655.8,4.7,8.29-1.128,12.217s-29.294,14.527-34.728,21.34c-2.106,2.641-2.421,1.985-1.55-.275C482.058,368.378,504.579,345.265,515.115,346.364Z",
    transform: "translate(-477.256 -346.326)",
    fill: "#0076bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13614",
    "data-name": "Path 13614",
    d: "M477.566,384.414c-.319.123-.383-.185-.233-.812,10.752-17.744,39-30.732,39.091-30.775a.31.31,0,0,1,.261.563C516.595,353.432,487.961,366.6,477.566,384.414Z",
    transform: "translate(-477.256 -349.129)",
    fill: "#05304b",
    fillRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13623",
    "data-name": "Path 13623",
    d: "M682.715,415.8a.621.621,0,0,0-1.242,0v1.461h-1.459a.621.621,0,0,0,0,1.243h1.459v1.462a.621.621,0,1,0,1.242,0v-1.462h1.46a.621.621,0,0,0,0-1.243h-1.46Z",
    transform: "translate(-320.072 -208.095)",
    fill: "#bfcce8",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11351",
    "data-name": "Group 11351",
    transform: "translate(151.574 144.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    d: "M2.876,0H93.318a2.876,2.876,0,0,1,2.876,2.876v0a2.875,2.875,0,0,1-2.875,2.875H2.875A2.875,2.875,0,0,1,0,2.876v0A2.876,2.876,0,0,1,2.876,0Z",
    transform: "translate(0 54.433)",
    fill: "#a8a6b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13624",
    "data-name": "Path 13624",
    d: "M406.507,409.231H316.057a3.085,3.085,0,0,1-2.517-1.356,2.683,2.683,0,0,1,2.355-1.355h90.45a3.087,3.087,0,0,1,2.516,1.355A2.68,2.68,0,0,1,406.507,409.231Z",
    transform: "translate(-313.012 -349.047)",
    fill: "#96929f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13625",
    "data-name": "Path 13625",
    d: "M422.927,359.588H350.583a3.5,3.5,0,0,1-3.521-3.763l2.962-46.908a4.074,4.074,0,0,1,4-3.762h72.344a3.5,3.5,0,0,1,3.521,3.762l-2.962,46.908A4.073,4.073,0,0,1,422.927,359.588Z",
    transform: "translate(-327.544 -305.155)",
    fill: "#96929f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13626",
    "data-name": "Path 13626",
    d: "M424.562,359.588H354.351a3.5,3.5,0,0,1-3.521-3.763l2.962-46.908a4.074,4.074,0,0,1,4-3.762H428a3.5,3.5,0,0,1,3.52,3.762l-2.962,46.908A4.073,4.073,0,0,1,424.562,359.588Z",
    transform: "translate(-329.178 -305.155)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13627",
    "data-name": "Path 13627",
    d: "M422.876,359.588h-7.225l-59.893-47.92.174-2.751a3.963,3.963,0,0,1,.858-2.2l66.086,52.875ZM364.9,305.155l65.334,52.274a3.908,3.908,0,0,0,.461-1.6l.461-7.294-54.215-43.376Z",
    transform: "translate(-331.318 -305.155)",
    fill: "#f0eef0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    d: "M2.876,0H19.307a2.876,2.876,0,0,1,2.876,2.876v0a2.875,2.875,0,0,1-2.875,2.875H2.875A2.875,2.875,0,0,1,0,2.876v0A2.876,2.876,0,0,1,2.876,0Z",
    transform: "translate(0 54.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13628",
    "data-name": "Path 13628",
    d: "M420.97,401.5H345.7a1.55,1.55,0,0,1-1.522-1.437h0a1.342,1.342,0,0,1,1.35-1.438H420.8a1.551,1.551,0,0,1,1.523,1.438h0A1.342,1.342,0,0,1,420.97,401.5Z",
    transform: "translate(-326.298 -345.626)",
    fill: "#d2ced6",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11352",
    "data-name": "Group 11352",
    transform: "translate(11.65 93.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13629",
    "data-name": "Path 13629",
    d: "M301.949,262.149a14.933,14.933,0,0,1,.115-6.935l-11.86-1,16.508-7.242a38.171,38.171,0,0,0,5.155-8.53c1.652-4.227-2.827-14.975-4.51-17.642s-5.18-2.267-7.483-.824c0,0-3.458-5.216-7.586-5.565s-17.249.862-21.06,10.5,2.321,19.273-3.818,29.189a2.472,2.472,0,0,0,.256,2.31c.8,1.057,10.475,12.348,32.532,7.8a2.243,2.243,0,0,0,1.751-2.058Z",
    transform: "translate(-153.008 -214.357)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13630",
    "data-name": "Path 13630",
    d: "M286.4,281.721c1.215-13.277,2.071-24.817,2.071-24.817l-1.125-3.742s-10.157,8.217-17.368-.428c.343,5.931,1.189,11.9-2.573,17.981a2.472,2.472,0,0,0,.256,2.311l.032.043.012.014.028.035.029.036.018.023.052.062,0,0,.062.074.018.021.052.06.044.051.034.037.076.085.01.01.093.1.021.023.081.086.056.06.053.054.038.039.079.08.125.126.087.084.065.065c2.11,2.043,7.026,5.823,15.309,7.135l.024,0q1.077.17,2.231.282Z",
    transform: "translate(-153.008 -230.974)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13631",
    "data-name": "Path 13631",
    d: "M306.193,288.523c-.754-3.756-.227-5.266.825-10.284l-18.874-2.973-8.248,1.6a55.394,55.394,0,0,1-2.877,10.223c5.022,3.112,13.893,6.282,27.423,3.491a2.243,2.243,0,0,0,1.751-2.058Z",
    transform: "translate(-157.253 -240.731)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13632",
    "data-name": "Path 13632",
    d: "M265.648,299.656c5.223,1.64,12.363,3.6,18.519,6.63.425.21-.442,1.85-.047,2.069a14.435,14.435,0,0,1,2.7,2.2c2.876,2.846,8.727,25.123,8.2,27.342-.841,3.57-8.233,13.379-8.233,13.379-1.468,2.838-3.288,6.972-5.076,11.44H245c2.557-8.322,3.509-13.959,3.577-19.04h0c1.96-17.272-7.317-21.03-7.317-21.03l9.608-22.634c3.738-1.325,11.192-.827,11.192-.827A7.637,7.637,0,0,1,265.648,299.656Z",
    transform: "translate(-141.749 -251.048)",
    fill: "#e74d91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13633",
    "data-name": "Path 13633",
    d: "M297.969,369.77h-5.182c.966-2.587,5.458-14.821,6.418-17.432-4.367-.761-10.379-1.8-11.438-2.057s-5.119,2.069-5.119,2.069l.451-2.64-4.358,4.393,7.451-13.929s12.158,2.749,14.742,3.22,1.008.112,1.488.074c1.436-4.045-.916-5.177-.637-7.135s.362-20.946.362-20.946c1.571.815,2.281,2.586,3.17,5.381.585,1.839,3.689,13.924,4.974,21.072.306,1.7.548,2.973.7,3.988C308.111,353.18,301.644,360.582,297.969,369.77Z",
    transform: "translate(-157.999 -258.104)",
    fill: "#b92f6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13634",
    "data-name": "Path 13634",
    d: "M294.7,263.287l-1.838,5.528s-2.781,13.045-3.423,14.737c-.224.587-.959.767-2.089.739,1.627,2.332,4.786,5.89,9.353,6.756a8.851,8.851,0,0,0,6.34-.809c-.975-.515-1.908-1.128-1.9-1.631.04-4.452.8-12.288,3.214-13.737C307.11,273.212,294.7,263.287,294.7,263.287Z",
    transform: "translate(-161.73 -235.544)",
    fill: "#e8685b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13635",
    "data-name": "Path 13635",
    d: "M286.948,300.189a11.6,11.6,0,0,1-2.632-.1,19.884,19.884,0,0,0,5.846,5.287c7.2,4.568,10.669,2.079,11.765.9a8.033,8.033,0,0,1-1.755-1.128h0c-6.72,3.287-13.224-4.962-13.224-4.962Z",
    transform: "translate(-160.417 -251.478)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13636",
    "data-name": "Path 13636",
    d: "M311.6,311.524s2.872,28.931,2.523,31.375-4.914,14.483-8.916,25.195h6.881c1.359-2.622,2.4-4.669,2.587-5.162.123-.319.6-1.244,1.252-2.456,1.176-2.179,2.932-5.287,4.256-7.462,4.219-6.933,4.208-5.314,2.748-13.436-1.285-7.148-5.229-20.374-5.814-22.213C316.23,314.568,312.347,311.32,311.6,311.524Z",
    transform: "translate(-169.476 -256.427)",
    fill: "#1c2344",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13637",
    "data-name": "Path 13637",
    d: "M313.344,380.1c-.946,2.647-2.046,5.661-3.187,8.755a22.961,22.961,0,0,1,4.355.624c2.092.823,2.311,1.761,2.311,1.761.122-.319.6-1.244,1.252-2.456,1.176-2.18,2.932-5.287,4.256-7.462,1.269-2.086,2.155-3.4,2.734-4.432a11.962,11.962,0,0,1-2.737,1.981C321.566,379.1,315.7,379.816,313.344,380.1Z",
    transform: "translate(-171.621 -284.734)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13638",
    "data-name": "Path 13638",
    d: "M263.624,298.694s5.269,25.553,5.991,32.981-1.6,12.744-4.209,18.325c-.88,1.881-3.7,6.682-7.177,12.368H242l1.735-40.14-4.652-1.08c.276-2.016.5-3.686.657-4.856l9.16-16.213S252.358,297.276,263.624,298.694Z",
    transform: "translate(-140.806 -250.702)",
    fill: "#1c2344",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13639",
    "data-name": "Path 13639",
    d: "M253.761,318.035c-2.588,10.406-.791,14.721-.791,14.721l1.387-6.475s1.311,9.558,2.77,10.776c.724.606,9.348,2.261,12.58,2.864a27.167,27.167,0,0,1-1.588,10.706c-2.319.239-16.274-1.729-16.941,2.784-.332,2.251-.258-4.991-.258-4.991l-.826,20.99H242l1.735-40.14-4.652-1.08.012-.095.013-.093.013-.094.012-.093h0l.013-.092.012-.092.012-.091.012-.091.012-.09.012-.09.012-.089h0l.012-.089.012-.088.011-.087h0l.012-.086.011-.086h0l.012-.086h0l.011-.085h0l.012-.085h0l.011-.083h0l.011-.083h0l.011-.083h0l.011-.082h0l.011-.082h0l.011-.081h0l.011-.08h0l.011-.08h0l.011-.079h0l.011-.079h0l.011-.078h0l.01-.077h0l.01-.077h0l.011-.076h0l.01-.075h0l.01-.075h0l.01-.074h0l.01-.073h0l.01-.073h0l.01-.072h0l.01-.072h0l.009-.071h0l.01-.07h0l.01-.07h0l.009-.069h0l.01-.068h0l.009-.068h0l.009-.067h0l.009-.066h0l.009-.065h0l.008-.065h0l.009-.065h0l.009-.063h0l.009-.063h0l.008-.062h0l.008-.061h0l.009-.06h0l.008-.061h0l.008-.059h0l.008-.058h0l.007-.058h0l.008-.057h0l.007-.056h0l.007-.055h0l.007-.055,4.961-8.779Z",
    transform: "translate(-140.806 -257.743)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13640",
    "data-name": "Path 13640",
    d: "M240.217,312.108c-2.97,8.125-3.778,35.99-1.331,50.949h13.033c-5.33-29.695,5.865-50.935,3.405-58.46C251.387,292.551,242.17,306.768,240.217,312.108Z",
    transform: "translate(-140.092 -251.39)",
    fill: "#383d5d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13641",
    "data-name": "Path 13641",
    d: "M331.235,267.492l1.452-.637a41.938,41.938,0,0,0,4.227-6.483c-.346.659-2.634,4.665-5.985,2.217-3.643-2.664-3.79,1.554-3.79,1.554a16.832,16.832,0,0,0,3.484,3.092c.165.076.374.163.612.257Zm5.723-7.207v0h0Z",
    transform: "translate(-178.985 -234.243)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13642",
    "data-name": "Path 13642",
    d: "M328.135,268.711a4.159,4.159,0,1,0,3.7,4.565A4.157,4.157,0,0,0,328.135,268.711Z",
    transform: "translate(-177.43 -237.883)",
    fill: "#e8685b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13643",
    "data-name": "Path 13643",
    d: "M277.527,263.522c-.1,0-.206.014-.308.026h0a4.158,4.158,0,1,0,3.385,1.125c0,1.232-.32,2.729-1.892,2.749l.246-2.385A1.428,1.428,0,0,0,277.527,263.522Z",
    transform: "translate(-155.758 -235.646)",
    fill: "#e8685b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13644",
    "data-name": "Path 13644",
    d: "M299.107,229.361h0a14.276,14.276,0,0,0-15.62,12.7l-1.332,12.877a14.282,14.282,0,0,0,12.689,15.636h0a14.275,14.275,0,0,0,15.62-12.7L311.8,245A14.282,14.282,0,0,0,299.107,229.361Z",
    transform: "translate(-159.447 -220.821)",
    fill: "#f4ad85",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13645",
    "data-name": "Path 13645",
    d: "M283.254,250.1l-1.1,10.619a14.3,14.3,0,0,0,9.07,14.769c-8.282-3.434-4.036-17.845-4.036-17.845,1.677-.286,4.322-3.415,5.86-5.236s2.728-3.658,5.381-3.6a54.7,54.7,0,0,1,8.261,1.448,15.616,15.616,0,0,0,4.56,5.783l.544-5.256a14.146,14.146,0,0,0-.27-4.573c-.343-.2-.7-.406-1.068-.616C299.061,239.174,289.388,244.363,283.254,250.1Z",
    transform: "translate(-159.447 -226.6)",
    fill: "#ed9072",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13646",
    "data-name": "Path 13646",
    d: "M318.408,247.055l-2.3.979a6.783,6.783,0,0,0-4.64-.747s-5.053-1.859-7.73-.823-1.1-2.686-.612-2.849a32.693,32.693,0,0,1,7.775-.059c2.214.426,5.543.946,5.543.946Z",
    transform: "translate(-168.178 -226.908)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13647",
    "data-name": "Path 13647",
    d: "M283.008,262.307l1.364.24s.947,4.316-1.73,4.35l.246-2.385a1.351,1.351,0,0,0-.028-.457Z",
    transform: "translate(-159.691 -235.119)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13648",
    "data-name": "Path 13648",
    d: "M302.216,239.668c-2.08-2.809-5.479-3.384-8.122.562-2.413,3.6-6,9.843-12.033,9.334l-.03-.111.014,0,.34-4.025s-.508.133-1.125.278a26,26,0,0,1-.208-7.213c.7-5.058,7.728-12.447,15.659-12.731s13.666,4.429,14.8,7.118a60,60,0,0,1,2.258,8.787l-1.4,2-1.5,3.971c-3.648-3.552-3.273-6.912-4.859-8.6C305.156,238.117,303.872,238.114,302.216,239.668Z",
    transform: "translate(-158.928 -219.291)",
    fill: "#0e1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13649",
    "data-name": "Path 13649",
    d: "M293.444,253.491c-2.393,3.625-5.827,8.539-11.208,8.085l-.03-.111.014,0,.34-4.025s-.508.133-1.125.278c-.053-.348-.1-.712-.15-1.087C287.362,258.4,293.424,253.507,293.444,253.491Z",
    transform: "translate(-159.102 -231.302)",
    fill: "#010518",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13650",
    "data-name": "Path 13650",
    d: "M313.423,309.786s3.7,30.408,3.629,31.4S316,346.924,316,346.924a20.065,20.065,0,0,0,2.226-5.486c.438-2.487,1.607-19.308,1.607-19.308l-1.972-1.06,1.827-.11-3.015-9.447a2.668,2.668,0,0,0-.821-.975c-.475-.275-2.205-1.144-2.233-1.157a1.129,1.129,0,0,0-.677.082S313.3,309.707,313.423,309.786Z",
    transform: "translate(-172.827 -255.495)",
    fill: "#484e6a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13651",
    "data-name": "Path 13651",
    d: "M278.483,298.728s5.269,25.553,5.991,32.981a26.384,26.384,0,0,1-.456,8.234c.971-7.6-9.711-25.477-9.711-25.477l2.776-1.317-3.726-1.682s1.717-9.617,1.827-11.226c.106-1.564-.722-1.855-.768-1.871C275.642,298.427,276.993,298.541,278.483,298.728Z",
    transform: "translate(-155.665 -250.735)",
    fill: "#484e6a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13652",
    "data-name": "Path 13652",
    d: "M82.965,422.038h4.613a3.355,3.355,0,0,0,3.343-3.346h0a3.356,3.356,0,0,0-3.343-3.347H75.391a2.663,2.663,0,0,1-2.654-2.655h0a2.663,2.663,0,0,1,2.654-2.657H397.341a2.663,2.663,0,0,1,2.654,2.657h0a2.663,2.663,0,0,1-2.654,2.655H380.629a3.355,3.355,0,0,0-3.343,3.347h0a3.354,3.354,0,0,0,3.343,3.346h3.917a5.324,5.324,0,0,1,5.306,5.312h0a5.326,5.326,0,0,1-5.306,5.312H82.965a5.327,5.327,0,0,1-5.307-5.312h0a5.325,5.325,0,0,1,5.307-5.312Zm-14.744-12a2.656,2.656,0,1,1-2.654,2.657A2.656,2.656,0,0,1,68.221,410.033Z",
    transform: "translate(-65.567 -299.086)",
    fill: "#01020e",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13725",
    "data-name": "Path 13725",
    d: "M288.429,807.687a38.373,38.373,0,1,0,0,54.268A38.373,38.373,0,0,0,288.429,807.687Zm-47.59,6.678a28.944,28.944,0,0,1,36.863-3.378l-40.241,40.241a28.944,28.944,0,0,1,3.377-36.863ZM261.3,863.75a28.72,28.72,0,0,1-16.407-5.1l40.241-40.241A28.934,28.934,0,0,1,261.3,863.75Z",
    transform: "translate(-77.669 -748.943)",
    fill: "#ff1515"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.93f5d375c2d2e8686b36ffc5f63096b8.svg";
export { ForwardRef as ReactComponent };